<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-form-group horizontal label="Filter" label-cols="1" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.orderno" placeholder="Nomor Order" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-form-input v-model="tblData.orderdate" placeholder="Tgl Order" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCust"
          responsive
          striped hover
          style="font-size:small;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD/MM/YYYY") }}
        </template>
        <template v-slot:cell(total)="data">
          {{data.item.total | numFormat}}
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>
<style lang="scss">
  .lku-charges {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import opi from "../../apis/koran_iklanorder";
export default {
  data() {
    return {
      fields: [
         {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
            // thStyle: "width:60px",
            // thClass: "text-center",
          },
          {
            key: "posisirubrik",
            label: "Posisi Iklan",
          },
          {
            key: "ukuraniklan",
            label: "ukuran Iklan",
          },
          {
            key: "total",
            label: "Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'orderno',
        sortDesc: false,
        posted: '1',completed:'0'
      },
      lkuLoading:false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await opi.list(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={orderno:'', orderdate: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCust.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCust.refresh();
    }
  }
};
</script>
